// Module
var code = "<widget-wrapper widget=\"$ctrl.widget\" class=\"grid-stack-item-content panel\" on-lock-widget=\"$ctrl.onLockWidget\"> <pie-chart style=\"position:relative;display:block;height:100%\" data=\"$ctrl.widget.data\" options=\"$ctrl.widget.options\" class=\"pie-chart\"></pie-chart> </widget-wrapper> ";
// Exports
export default code;